<template>
  <div class="bggray">
    <app-header />
    <div class="orderWrap">
      <div class="orderNav">
        <span class="cur">确认购买信息</span>
        <span class="cur">选择支付方式</span>
        <span>购买成功开通权限</span>
      </div>
      <div class="mod orderInfo">
        <h3 class="title">订单详情</h3>
        <ul class="column5">
          <li>
            <div>产品名称</div>
            <div>订单编号</div>
            <div>期限</div>
            <div>实付款（元）</div>
            <div>支付方式</div>
          </li>
          <li>
            <div>{{orderInfo.productName}}</div>
            <div>{{orderInfo.id}}</div>
            <div>{{orderInfo.monthCount | formatQuantity(dateUnit)}}</div>
            <div>{{orderInfo.payMoney}}</div>
            <div v-if="this.payMode == 23">微信支付</div>
            <div v-else >企业微信支付</div>
          </li>
        </ul>
        <p class="time">
          下单时间：
          <time v-if="orderInfo.orderTime">{{orderInfo.orderTime | dateFormat}}</time>
        </p>
        <div class="wx-box">
          <p class="title">请您在提交订单后24小时完成支付，否则订单会自动取消</p>
          <div class="qr-con" v-if="this.payMode == 23">
            <!-- <img src="" class="qr-img" id="wxQrCodeImg"> -->
            <qriously class="qr-img" :value="qrData" :size="300" :level="M" />
            <span class="btn">
              请使用微信扫一扫
              <br />扫描二维码支付
            </span>
          </div>
          <div class="qr-con" v-if="this.payMode == 42">
            <!-- <img src="" class="qr-img" id="wxQrCodeImg"> -->
            <img :src="qrData" alt="" width="300px" height="300px">
            <span class="btn">
              请使用微信扫一扫
              <br />扫描小程序码支付
            </span>
          </div>
          <div class="wx-bottom">
            <router-link :to="'/order/pay/' + orderInfo.id">
              <i>&lt;</i>选择其他支付方式
            </router-link>
            <router-link :to="'/order/detail/' + orderInfo.id">
              支付完成，查看我的订单
              <i>&gt;</i>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <app-footer />
  </div>
</template>
<script>
import AppHeader from "@/components/common/AppHeader.vue";
import AppFooter from "@/components/common/AppFooter.vue";

export default {
  data() {
    return {
      orderId: this.$route.params.orderId,
      payMode: this.$route.params.payMode,
      orderInfo: {},
      qrData: "",
      dateUnit: ''
    };
  },
  created() {
    this.getOrder();
    this.getQrCode();
    this.getOrderStatusTimer();
  },

  beforeDestroy() {
    if(this.orderStatusTimer){
      clearInterval(this.orderStatusTimer)
    }
  },

  methods: {
    getOrder() {
      this.$get("/order/query?id=" + this.orderId)
        .then(response => {
          if (response.code === 0) {
            this.orderInfo = response.data;
            this.dateUnit = response.data.dateUnit
          } else if (response.code != 100) {
            this.$global.alertAndGoHistory(response.msg);
          }
        })
        .catch(err => {
          this.$global.alertAndGoHistory("网络异常，请稍后重试。");
        });
    },
    getQrCode() {
      var url = "/pay/qrcode"
      var params = {
        id: this.orderId,
        payMode: this.payMode
      };
      if(this.payMode == 42) {
        url = "/pay/weComQrcode"
      }
      this.$get(url, params)
        .then(response => {
          if (response.code === 0) {
            this.qrData = response.data;
          } else if (response.code != 100) {
            this.$global.alertAndGoHistory(response.msg);
          }
        })
        .catch(err => {
          this.$global.alertAndGoHistory("网络异常，请稍后重试。");
        });
    },
    getOrderStatusTimer() {
      var count = 60;
      this.orderStatusTimer = setInterval(() => {
        if (count <= 0) {
          clearInterval(this.orderStatusTimer);
        } else {
          count--;
          this.$get("/order/status?id=" + this.orderId).then(response => {
            if (response.code === 0 && (response.data == 1 || response.data == 9)) {
              clearInterval(this.orderStatusTimer);
              this.$router.push("/order/detail/" + this.orderId);
            }
          });
        }
      }, 5000);
    },
  },
  filters: {
    formatQuantity (month, dateUnit) {
      if(dateUnit === 'day') {
        if (month === 1) {
          return month + '个月'
        } else if (month === 7) {
          return '7天'
        } else if (month === 14) {
          return '14天'
        }
      } else {
         return month + '个月'
      }
    }
  },
  components: {
    AppHeader,
    AppFooter
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/scss/order.scss";
.orderInfo {
  .time {
    @include fc(16px, #222);
    line-height: 30px;
    text-align: right;
  }
}
.wx-box {
  background: #ffffff url("~@/assets/images/pay/phone-bg.png") no-repeat 550px
    100px;
  padding: 20px 30px 40px;
  &:before,
  &:after {
    display: table;
    content: "";
    line-height: 0;
  }
  &:after {
    clear: both;
  }
  .title {
    @include fc(20px, #fff);
    background: #166eff;
    @include vertical-center(560px, 36px);
    margin: 0 auto 70px;
    letter-spacing: 1px;
  }
  .qr-img {
    width: 300px;
    height: 300px;
    padding: 5px;
    border: 1px solid #ddd;
  }
  .qr-con {
    float: left;
    margin-left: 100px;
  }
  .wx-bottom {
    clear: both;
    padding: 40px 0 10px;
    font-size: 18px;
    text-align: center;
    a {
      color: #5da5ef;
      text-decoration: none;
      &:first-child {
        margin-right: 100px;
      }
    }
    i {
      margin-right: 10px;
      font-style: normal;
    }
  }
  .btn {
    display: block;
    background: #ff4e48 url("~@/assets/images/icon/icon-red.png") no-repeat 10px
      center;
    color: #fff;
    width: 232px;
    padding: 5px 0 5px 80px;
    margin-top: 10px;
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/pay/PayQRCode.vue